import { render, staticRenderFns } from "./Orderdetail_.vue?vue&type=template&id=55ec63d8&scoped=true&"
import script from "./Orderdetail_.vue?vue&type=script&lang=js&"
export * from "./Orderdetail_.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetail_.vue?vue&type=style&index=0&id=55ec63d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec63d8",
  null
  
)

export default component.exports